import { Trans, useTranslation } from 'react-i18next';
import { Icon, Card } from '@uva-glass/component-library';

import styles from './ErrorPage.module.css';

import { Page } from 'components';
import { ActionHeader } from 'App/shared/ActionHeader';

interface Props {
  message?: string;
  userUnavailable?: boolean;
  noHeader?: boolean;
}

export function ErrorPage({ message, userUnavailable, noHeader }: Props) {
  const { t } = useTranslation('error');

  return (
    <Page documentTitle={t('title')} header={noHeader ? <div /> : <ActionHeader userUnavailable={userUnavailable} />}>
      <div className={styles['error-page__container']}>
        <Card highContrast padding="large" alignCenter>
          <div className={styles['error-page__icon']}>
            <Icon name="BrowserBroken" size={128} className={styles['error-page__icon']} />
          </div>
          <div className={styles['error-page__content']}>
            <div className={styles['error-page__text']}>
              <h1 className={styles['error-page__title']}>{t('title')}</h1>

              <Trans t={t} i18nKey="description">
                <p className={styles['error-page__description']}>
                  Reload the page to try again. If that doesn’t work, please contact us via email:
                  <a href="mailto:glass@uva.nl" target="_blank" rel="noreferrer">
                    glass@uva.nl
                  </a>
                  You can include the error message below.
                </p>
              </Trans>
            </div>
            <Card padding="small" alignCenter>
              <h2 className={styles['error-page__error-title']}>{t('error.title')}</h2>
              <p className={styles['error-page__error-message']}>
                {message ? <small>{message}</small> : t('error.placeholder')}
              </p>
            </Card>
          </div>
        </Card>
      </div>
    </Page>
  );
}
